import React, { useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import NotFound from './components/NotFound/NotFound';
import TransitionOverlay from './components/Transition/TransitionOverlay';
import { TransitionContext } from './context/TransitionContext';

function Root() {
  const overlayRef = useRef(null);

  return (
    <TransitionContext.Provider value={overlayRef}>
      <TransitionOverlay ref={overlayRef} />
      <Routes>
        <Route path="/" element={<App />} />
<Route path="*" element={<NotFound />} />
      </Routes>
    </TransitionContext.Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </React.StrictMode>
);
